declare global {
  interface Window {
    inituser: {
      id: string;
      name: string;
    };
  }
}

export function visitorId() {
  let userId = localStorage.getItem('your_visitor_id');

  if (!userId || userId == 'null') {
    userId = window.crypto.randomUUID()+'-'+window.crypto.randomUUID()
  }

  if (user && user?.value?.email && !userId.includes(user?.value?.email)) {
    userId = user?.value?.email+'_'+userId;
  }

  localStorage.setItem('your_visitor_id', userId);

  return userId;
}

export function ucfirst(str: string) {
  return str?.charAt(0)?.toUpperCase() + str?.slice(1);
}

export function toNormalCase(str: string) {
  return str
    ?.toLowerCase()
    .replace(/(^|[\s-])(\S)/g, (_, separator, char) => separator + char.toUpperCase());
}

export function showReportBugModal() {
  useState('dataShowBugReport').value = true
}

export function getCssPath(el: HTMLElement | null): string {
  if (!el || el.tagName?.toLowerCase() === 'html') return 'html';
  const parent = el.parentElement;
  const tag = el.tagName?.toLowerCase();
  const siblings = parent ? Array.from(parent.children).filter(e => e.tagName === el.tagName) : [];
  const index = siblings.length > 1 ? `:nth-of-type(${siblings.indexOf(el) + 1})` : '';

  const suffix = tag ? `${tag}${index}` : '';
  const r = getCssPath(parent);

  const result = suffix ? `${r}>${suffix}` : r;

  // first item from current selector
  // result += '>*'


  return result;
}

// Transform '123.4' into '123.400'
export function floatPrecision(preciable: number|string, precision: number = 3) : string {
  if (preciable === null || preciable === undefined) {
    return '';
  }

  const str = String(preciable);
  const parts = str.split('.');

  if (parts.length === 1) {
    return str + '.' + '0'.repeat(precision);
  } else if (parts[1].length < precision) {
    return str + '0'.repeat(precision - parts[1].length);
  } else {
    return str;
  }
}

export function truncate(str: string, n: number, ellipsis: boolean = true) {
  return (str?.length > n) ? str.substr(0, n-1) + (ellipsis ? '…' : '') : str;
}
